import CardManagement from '@/views/webpc/CashierDesk/CardManagementApp/CardManagement'
import CardManagementAnother from '@/views/webpc/CashierDesk/CardManagementApp/CardManagementAnother'
import CardManagementRecords from '@/views/webpc/CashierDesk/CardManagementApp/CardManagementRecords'

// 定义路由路径数列表
export default [{
  path: '/cardManagement',
  icon: 'el-icon-bank-card',
  name: '实体卡列表',
  component: CardManagement
},
{
  path: '/cardManagementAnother',
  icon: 'el-icon-bank-card',
  name: '实体卡列表',
  component: CardManagementAnother
},
{
  path: '/cardManagementRecords',
  icon: 'el-icon-bank-card',
  name: '扣款记录',
  component: CardManagementRecords
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CardManagementApp/routers/index.js